// Calcula cuántos caracteres de relleno (*, -, etc.) caben realmente en el
// espacio disponible del "Cantidad en Letras", en vez de repetir 300
// caracteres y confiar en que el CSS los recorte (así se comportaba el
// generador original, y por eso podía truncar el monto real sin avisar).
//
// Como la fuente es monoespaciada (Courier New) y el texto usa
// word-break:break-all, el ancho de cada carácter es constante, así que
// podemos calcular con precisión cuántos caracteres entran en las líneas
// disponibles usando un <canvas> para medir el ancho real de fuente.

const MM_POR_PX = 25.4 / 96;

function medirAnchoCaracterPx(fuentePt) {
  const canvas = medirAnchoCaracterPx.canvas || (medirAnchoCaracterPx.canvas = document.createElement('canvas'));
  const ctx = canvas.getContext('2d');
  const fontSizePx = fuentePt * (96 / 72);
  ctx.font = `bold ${fontSizePx}px "Courier New", monospace`;
  return { anchoCaracterPx: ctx.measureText('M').width, fontSizePx };
}

export function calcularTextoConRelleno({ texto, relleno, fuentePt, anchoMm, lineasMax = 2 }) {
  if (!anchoMm || !fuentePt) return { textoFinal: texto, desborda: false };

  const { anchoCaracterPx } = medirAnchoCaracterPx(fuentePt);
  const anchoDisponiblePx = anchoMm / MM_POR_PX;
  const caracteresPorLinea = Math.max(1, Math.floor(anchoDisponiblePx / anchoCaracterPx));
  const totalCaracteresDisponibles = caracteresPorLinea * lineasMax;

  if (texto.length >= totalCaracteresDisponibles) {
    // El monto en letras por sí solo ya no cabe: se muestra completo (nunca
    // se trunca) y se avisa para que el usuario reduzca el tamaño de letra.
    return { textoFinal: texto, desborda: true };
  }

  if (!relleno) {
    return { textoFinal: texto, desborda: false };
  }

  const espacioParaRelleno = totalCaracteresDisponibles - texto.length - 1; // -1 por el espacio separador
  if (espacioParaRelleno <= 0) {
    return { textoFinal: texto, desborda: false };
  }

  return { textoFinal: `${texto} ${relleno.repeat(espacioParaRelleno)}`, desborda: false };
}
